import Proposal from "../components/proposal/proposal";
import Propview from "../components/propview/propview";
function Propvieww(){
    return(
        <>
        <Proposal/>
        <Propview/>
        </>
    )
}
export default Propvieww